import { gsap } from 'gsap'
import modalX from '../vendor/modalX'
import { find, findAll } from '../utils/dom'

export default function () {
	const modal = modalX('menuMobile').init()
	const $Modal = modal.elModal
	const $Html = document.documentElement
	const $Body = document.body
	const $Contents = findAll('[js-modal-content]', $Modal)

	const setMenuHeight = () => {
		const height = window.visualViewport?.height ?? window.innerHeight
		$Modal.style.setProperty('--menu-mobile-height', `${height}px`)
	}

	const fixModalDimensions = () => {
		gsap.killTweensOf($Modal)
		$Contents.forEach((panel) => panel.style.removeProperty('position'))
		$Modal.style.removeProperty('height')
		$Modal.style.removeProperty('width')
		setMenuHeight()
	}

	const lockScroll = () => {
		setMenuHeight()
		$Html.classList.add('menuMobile-open')
		$Body.classList.add('menuMobile-open')
	}

	const unlockScroll = () => {
		$Html.classList.remove('menuMobile-open')
		$Body.classList.remove('menuMobile-open')
		$Modal.style.removeProperty('--menu-mobile-height')
		$Modal.style.removeProperty('height')
		$Modal.style.removeProperty('width')
	}

	const switchPanel = (id) => {
		modal.getState().idActive = id
		$Modal.dataset.active = id
		$Contents.forEach((panel) => {
			panel.classList.toggle('active', panel.dataset.id === id)
			panel.style.removeProperty('position')
			panel.style.removeProperty('max-height')
		})
		fixModalDimensions()
	}

	const onViewportChange = () => {
		if (modal.getState().open) {
			fixModalDimensions()
		}
	}

	window.visualViewport?.addEventListener('resize', onViewportChange)
	window.addEventListener('resize', onViewportChange)

	findAll('[data-xopen="menuMobile"]').forEach((trigger) => {
		trigger.addEventListener('click', (ev) => ev.preventDefault())
	})

	const originalOpen = modal.openModal.bind(modal)
	modal.openModal = (item, classX) => {
		const targetId = typeof item === 'object' ? item.dataset.id : item

		if (modal.getState().open && targetId) {
			switchPanel(targetId)
			return modal
		}

		lockScroll()
		const result = originalOpen(item, classX)
		fixModalDimensions()
		requestAnimationFrame(fixModalDimensions)
		setTimeout(fixModalDimensions, 700)
		return result
	}

	const originalClose = modal.closeModal.bind(modal)
	modal.closeModal = (...args) => {
		gsap.killTweensOf($Modal)
		$Contents.forEach((panel) => {
			panel.style.removeProperty('position')
			panel.style.removeProperty('max-height')
		})
		const result = originalClose(...args)
		unlockScroll()
		return result
	}
}
